import React, { useEffect, useMemo, useRef, useState } from "react";
import { getToken } from "../lib/utils";
import QrScanner from 'react-qr-scanner'
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "../components/ui/navigation-menu";
import ParticipantsDialog from "../components/DialogBox";
import { Link } from "react-router-dom";
import axios from "../axios";
import { Dialog, DialogClose, DialogContent, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { DialogDescription } from "@radix-ui/react-dialog";

import CheckMark from '../images/check-mark.png'
import XMark from '../images/x-mark.png'


export default function DashboardPage() {
  const [participants, setParticipants] = useState(localStorage.getItem('participants') ? JSON.parse(localStorage.getItem('participants')) : []);
  const [attended, setAttended] = useState(localStorage.attended ? JSON.parse(localStorage.getItem("attended")): []);
  const [ qrStatus, setQrStatus ] = useState({ loading: false, message: null, status: null });
  const [ syncLoading, setSyncLoading ] = useState(false)
  const [qrerror, setQrError] = useState(null);
  const [success, setSuccess] = useState(false);

  const participants_Ids = useMemo(() => participants.map( p => p.registrationId ), [ participants ])


  useEffect(() => {
    try {
      if( !participants.length ){ fetchParticipants() }
    } catch (error) {
      console.log("error:", error)
    }
  }, []);


  const handleAttended = ( regId ) => {

    if( !participants_Ids.includes(regId) || regId === null || regId === "undefined" )  return setQrStatus(prev => ({ ...prev, loading: false, message: "Not registered participants.", status: "FAIL" }))
    if ( attended.includes(regId) ) return setQrStatus(prev => ({ ...prev, loading: false,  message: "You are already attended.", status: "FAIL" }))

    setAttended([...attended, regId]);
    localStorage.setItem('attended', JSON.stringify([...attended, regId]))
    return setQrStatus(prev => ({ ...prev, loading: false, message: "Participant verified.", status: "PASS" }))
  }


  const handleScan = (data) => {
    if (data && data.text) {
      if (success) return;
      setSuccess(true)

      setQrStatus({ loading: true, message: null })
      handleAttended( data.text )
    }

  };

  const handleError = (err) => {
    let message = "QR Scan error: ";
    if (err && err.name === "NotAllowedError") {
      message += "Camera access was denied. Please allow camera access.";
    } else if (err && err.name === "NotFoundError") {
      message += "No camera found on this device.";
    } else if (err && err.name === "NotReadableError") {
      message += "Camera is already in use by another application.";
    } else if (err && err.message) {
      message += err.message;
    } else {
      message += JSON.stringify(err);
    }
    setQrError(message);
  };

  const fetchParticipants = async () => {
    try {
      const res = await axios.get('/participants')
      setParticipants(res.data);
      localStorage.setItem('participants', JSON.stringify(res.data))

      const attendedSync = res.data?.filter(p => p.attended)?.map(p => p.registrationId)
      localStorage.setItem("attended", JSON.stringify(attendedSync))
      setAttended(attendedSync)
    } catch (error) {
      console.error("error:", error)
    }
  };


  const handleExport = async () => {
    const token = getToken();
    if (!token) return alert("Not authenticated.");

    try {
      const res = await axios.get('/export', { responseType: "blob" })

      if (!res.data) {
        throw new Error("Export failed: ");
      }
      // const blob = await res.data
      const url = window.URL.createObjectURL(res.data);

      const cd = res.headers.get("Content-Disposition");
      let filename = "participants.xlsx";
      if (cd && cd.includes("filename=")) {
        filename = cd.split("filename=")[1].replaceAll('"', "").trim();
      }

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Export failed: " + err.message);
    }
  };


  const handleSignOut = () => {
    localStorage.removeItem("token");
    window.location.replace("/admin/login");
  };

  const handleAction = () => {
    setQrStatus({ loading: false, isVerified: false })
    setSuccess(false)
  }

  const handleSync = async () => {
    try {
      setSyncLoading(true)
      const res  = await axios.post('/sync', { attended })
      setParticipants(res.data);
      localStorage.setItem('participants', JSON.stringify(res.data))

      const attendedSync = res.data?.filter(p => p.attended)?.map(p => p.registrationId)
      localStorage.setItem("attended", JSON.stringify(attendedSync))
      setAttended(attendedSync)

    } catch (error) {
      console.error(error)
    }
    finally { setSyncLoading(false) }
  }

  const handleClose = () => {
    setSuccess(false); 
    setQrStatus({ loading: false, isVerified: null }); 
  }


  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", }} >
      <div className="flex justify-center mt-5 pt-4" >
        <div className="bg-white py-2 px-10 inline-flex items-center"
          style={{ borderRadius: "999px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", minHeight: "3.2rem", pointerEvents: "auto", }} >
          
          <NavigationMenu>
            <NavigationMenuList>

              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <ParticipantsDialog trigger={<Link>Participants</Link>} loading={false} participants={participants} />
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link onClick={handleExport}>Export</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link onClick={handleSignOut}>Sign Out</Link>
                </NavigationMenuLink>
              </NavigationMenuItem>

            </NavigationMenuList>
          </NavigationMenu>
        </div>
      </div>

      <h2 className="text-2xl font-bold mt-10 text-center text-white" style={{ filter: "drop-shadow(0 8px 32px rgba(0,0,0,0.85))", wordBreak: "break-word", whiteSpace: "normal", }} >
        Event Manage
      </h2>

      <div className="grid grid-cols-12 p-3 gap-4">
        <div className="mobile-side-space col-span-12 md:col-span-6 w-full"
          style={{
            background: "#18181b", border: "1px solid #39393b", borderRadius: 16, padding: 24,
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)", color: "#fff", display: "flex", flexDirection: "column"
          }}>

          <div className="flex items-center justify-between mb-2">
            <h2 className="text-xl font-bold" >
              Event Statistics
            </h2>

            <Link className="bg-white text-black mb-0 px-3 flex rounded text-sm" onClick={() => handleSync()}>{syncLoading ? "Syncing..." : "Sync Now"}</Link>
          </div>

          <div className="text-white">
            <span className=""> Total Registered:</span>
            { participants.length || 0 }
          </div>

          <div className="text-white">
            <span>Attended:</span>
            { attended?.length || 0 }
          </div>
        </div>

        <div className="col-span-12 md:col-span-6 flex flex-col items-center w-full" >
          <Dialog>
            <DialogTrigger asChild>
              <button className="text-black bg-white px-3 rounded">Open Scanner</button>
            </DialogTrigger>
            <DialogContent className="DialogContent participants-dialog" onClose={handleClose}>
              <DialogTitle className="DialogTitle">QR Code Scanner</DialogTitle>
              <DialogDescription className="overflow-auto">
                  <div className="flex items-center justify-center max-w-full border border-2 rounded-lg" style={{ width: "90vw", aspectRatio: "1 / 1" }}>
                    <QrScanner
                      delay={3000}
                      onError={handleError}
                      onScan={handleScan}
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        aspectRatio: "1 / 1",
                        margin: "0 auto",
                        borderRadius: "12px",
                        background: "#111",
                        boxSizing: "border-box",
                      }}
                      constraints={{ audio: false, video: { facingMode: "environment" } }}
                    />
                  </div>

                  {qrerror && (
                    <div style={{ color: "red", textAlign: "center", margin: "0.5rem 0" }}> {qrerror} </div>
                  )}


                  {
                    qrStatus.loading ?
                      <div className="flex items-center mt-4 p-2">
                        <svg class="mr-3 size-5 animate-spin ..." viewBox="0 0 24 24" style={{ background: "#6495ed" }}>
                        </svg>
                        <p>Verifying....</p>
                      </div>
                      : <div className="mt-4 flex items-center">
                          {qrStatus.status == "PASS" && <img src={CheckMark} width={"35px"} height={"35px"} className="mr-3"/>}
                          {qrStatus.status == "FAIL" && <img src={XMark} width={"35px"} height={"35px"} className="mr-3"/>}
                          <p className="text-lg">{ qrStatus.message}</p>
                        </div>
                  }

              </DialogDescription>

              <DialogClose>
                  <div className="flex justify-center mb-4">
                    <button className="text-black bg-white px-10 py-1 rounded-lg" onClick={handleClose}>Cancel</button>
                  </div>
              </DialogClose>
            </DialogContent>
          </Dialog>
        </div>
      </div>


      <style>{`

        @media (max-width: 800px) {
          .admin-table-container {
            padding: 8px !important;
            border-radius: 10px !important;
          }
          .admin-table-container table {
            font-size: 13px !important;
            min-width: 480px !important;
          }
        }
        @media (max-width: 600px) {
          .admin-table-container {
            padding: 3px !important;
            border-radius: 6px !important;
          }
          .admin-table-container table {
            font-size: 12px !important;
            min-width: 340px !important;
          }
          .table-outer-mobile-margin {
            margin-left: 7px !important;
            margin-right: 7px !important;
          }
        }
      `}</style>
    </div>
  );
}
